import { render, staticRenderFns } from "./DividerBlock.vue?vue&type=template&id=0feefb78&scoped=true&"
import script from "./DividerBlock.vue?vue&type=script&lang=js&"
export * from "./DividerBlock.vue?vue&type=script&lang=js&"
import style0 from "./DividerBlock.vue?vue&type=style&index=0&id=0feefb78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feefb78",
  null
  
)

export default component.exports